import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

export default function DeleteContainerModal({isDeleteModal, setIsDeleteModal, onDeleteClick,type}:any) {

  const handleClose = (option:string) => {
    if(option === 'Yes') {
        onDeleteClick();
    }
    setIsDeleteModal(false)
  }
  return (
    <div>
      <Dialog
        open={isDeleteModal}
        onClose={()=>handleClose('No')}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Do you want to delete this ${type} ?`}
        </DialogTitle>
        <DialogActions>
          <Button onClick={() =>handleClose('Yes')}>Yes</Button>
          <Button onClick={() => handleClose('No')}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
